export interface LinkPreviewRequestParams {
  q: string;
  fields?: string;
  block_content?: boolean;
}

export interface LinkPreviewErrorResponse {
  title: string;
  description: string;
  image: string;
  url: string;
  error: number;
}

export interface LinkPreviewResponse {
  title: string;
  description: string;
  image: string;
  url: string;
  canonical?: string;
  locale?: string;
  site_name?: string;
  image_x?: number;
  image_y?: number;
  image_size?: number;
  image_type?: string;
  icon?: string;
  icon_x?: number;
  icon_y?: number;
  icon_size?: number;
  icon_type?: string;
}

export class LinkPreview {
  constructor(
    public readonly title: string,
    public readonly description: string,
    public readonly image: string,
    public readonly url: string,
    public readonly canonical?: string,
    public readonly locale: string = 'en_US',
    public readonly siteName?: string,
    public readonly imageX?: number,
    public readonly imageY?: number,
    public readonly imageSize?: number,
    public readonly imageType?: string,
    public readonly icon?: string,
    public readonly iconX?: number,
    public readonly iconY?: number,
    public readonly iconSize?: number,
    public readonly iconType?: string
  ) {}

  static fromResponse(response: LinkPreviewResponse): LinkPreview {
    return new LinkPreview(
      response.title || '',
      response.description || '',
      response.image || '',
      response.url || '',
      response.canonical,
      response.locale || 'en_US',
      response.site_name,
      response.image_x,
      response.image_y,
      response.image_size,
      response.image_type,
      response.icon,
      response.icon_x,
      response.icon_y,
      response.icon_size,
      response.icon_type
    );
  }

  getDescriptionWithoutLink(): string {
    return this.description.replace(/https?:\/\/[^\s]+/g, '');
  }

  // 이미지 유효성 검증
  hasValidImage(): boolean {
    return this.imageSize !== undefined && this.imageSize > 0;
  }

  // 이미지 방향 계산
  getImageOrientation(): 'portrait' | 'landscape' | 'square' | 'unknown' {
    if (!this.imageX || !this.imageY) return 'unknown';
    if (this.imageX > this.imageY) return 'landscape';
    if (this.imageX < this.imageY) return 'portrait';
    return 'square';
  }
}
